import React from 'react';
import { useTranslation } from 'react-i18next';

const ExpressionsTableHeader = () => {
  const { t } = useTranslation();

  return (
    <thead>
      <tr>
        <th className="name-column">{t('common.title')}</th>
        <th className="name-column">{t('common.expression')}</th>
        <th className="operations-column">{t('common.operations')}</th>
      </tr>
    </thead>
  );
};

export default ExpressionsTableHeader;
